// extracted by mini-css-extract-plugin
module.exports = {"value__container":"ReportingValue_value__container__3HADP","icon":"ReportingValue_icon__2mPnX","text":"ReportingValue_text__29k-7"};